"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactIntl = require("react-intl");
var _default = exports["default"] = (0, _reactIntl.defineMessages)({
  title: {
    id: 'components.PhrasingLoading.ErrorSection.title',
    defaultMessage: 'Ocorreu um erro'
  },
  subtitle: {
    id: 'components.PhrasingLoading.ErrorSection.subtitle',
    defaultMessage: 'Verifique o sinal de internet e tente novamente'
  },
  buttonLabel: {
    id: 'components.PhrasingLoading.ErrorSection.buttonLabel',
    defaultMessage: 'Tentar novamente'
  }
});